import { renderOnePageStoreCheckout } from '@shopline/sl-checkout-module/onePageStoreCheckout';
import { attempt, isError } from 'lodash-es';
import '@shopline/sl-checkout-module/onePageStoreCheckout.css';
import prepareMainConfig from './utils/prepareMainConfig';
import initOnePageStoreToSdk from './utils/initOnePageStoreToSdk';
import onePageStoreEvent from './events';
import currencyService from '../../service/currencyService';
import reloadOnBackForward from './utils/reloadOnBackForward';
import parseEscapeData from '../../utils/parseEscapeData';

function mountOnePageStoreCheckout() {
  reloadOnBackForward();

  const appRoot = document.getElementById('one-page-store-checkout-app-root');

  if (!appRoot) return;

  function getCartData() {
    const initCartData = {
      cart: {},
      extraMainConfig: {},
      sessionData: undefined,
      sentryConfig: {},
    };

    const rawCartData =
      document.getElementById('sl-cart-init-data')?.textContent;
    const cartData = attempt(parseEscapeData, rawCartData);

    if (isError(cartData)) {
      console.error('Failed to get cart data', cartData);
      return initCartData;
    }

    return cartData;
  }

  const getGRecaptcha = async () =>
    new Promise((resolve) => {
      const unsubscribe = window.globalSDKObserver?.grecaptcha?.subscribe?.(
        (sdk) => {
          resolve(sdk);
          unsubscribe();
        },
      );
    });

  const {
    cart,
    extraMainConfig,
    paymentUnifyError,
    sessionData,
    sentryConfig,
  } = getCartData();

  const { pageEvent } = renderOnePageStoreCheckout(appRoot, {
    currencyService,
    mainConfig: prepareMainConfig(window.mainConfig, extraMainConfig),
    cart,
    csrfToken: document
      .querySelector('meta[name=csrf-token]')
      ?.getAttribute('content'),
    outerEvent: onePageStoreEvent,
    getGRecaptcha,
    paymentUnifyError,
    sessionData,
    sentryConfig,
  });

  initOnePageStoreToSdk(pageEvent);
}
mountOnePageStoreCheckout();
